import { IChartContainer } from "../models/base/chart-container.interface";
import { IChartDataService } from "../models/base/chart-data-service.interface";
import { CompanyLogoDataModel } from "../models/company-logo/company-logo-data.model";
import { IComponent } from "./component.interface";

export class CompanyLogoComponent implements IComponent {
    public id = '';

    private companyLogoElement: HTMLElement;
    private imgElement: HTMLImageElement;
    private model = new CompanyLogoDataModel();

    private chartService: IChartDataService;

    constructor(companyLogoElement: HTMLElement, base: IChartContainer) {
        this.companyLogoElement = companyLogoElement;
        this.imgElement = this.companyLogoElement.findFirst('img') as HTMLImageElement;
        this.chartService = base.chartService;
        this.subscribeCompanyLogoData()
        this.onImageLoaded();
    }

    private subscribeCompanyLogoData() {
        this.chartService.subscribeCompanyLogoData((companyLogoData: CompanyLogoDataModel) => this.setCompanyLogo(companyLogoData));
    }

    private setCompanyLogo(companyLogoData: CompanyLogoDataModel) {
        this.model = companyLogoData;
        this.imgElement.setAttribute('src', this.model.companyLogoUrl);
        this.companyLogoElement.style.backgroundColor = '';

        this.imgElement.removeClass('hidden');
    }

    private onImageLoaded() {
        this.imgElement.onerror = () => {
            this.imgElement.removeAttribute('src');
            this.companyLogoElement.style.backgroundColor = this.model.fallbackColor.toRGB();

            this.imgElement.addClass('hidden');
        };
    }
}
